import { render } from "./RegisterUser.vue?vue&type=template&id=04f43a14&scoped=true"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"

import "./RegisterUser.vue?vue&type=style&index=0&id=04f43a14&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f43a14"]])

export default __exports__